<template>
  <div class="my-10">
    <MyPublicationNav></MyPublicationNav>
    <div class="grid grid-cols-4 gap-4 max-lg:grid-cols-3 max-md:grid-cols-2 max-sm:grid-cols-1">
      <router-link
        v-for="item in publications"
        :key="`publication-request-link-${item.id}`"
        :to="{ name: 'viewMyPublicationRequest', params: { id: item.id } }"
      >
        <MyPublicationCard
          :key="`publication-request-card-${$route.fullPath}-${item.id}-${item.thumbnail || 'no-thumb'}`"
          :detail="item"
        />
      </router-link>
      <div v-show="publications.length === 0 && loading === false">
        <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.no_publications') }}</p>
      </div>
    </div>
    <div v-show="loading === true" class="flex justify-center mt-10" role="status">
      <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin fill-main-color"> </IconSpinner>

      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import MyPublicationCard from '@cmp/profile/MyPublicationCard.vue';
import MyPublicationNav from '@cmp/profile/MyPublicationNav.vue';
import IconSpinner from '@icons/IconSpinner.vue';
import { updateLastSeen } from '@/helpers';
export default {
  name: 'publicationRequests',
  components: {
    MyPublicationCard,
    MyPublicationNav,
    IconSpinner,
  },

  data() {
    return {
      loading: false,
      publications: [],
      page: 1,
      count: 0,
      next: null,
    };
  },
  methods: {
    infiniteScroll() {
      let scrollTop = document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      let clientHeight = document.documentElement.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 650) {
        if (this.next !== null && this.loading === false) {
          this.page += 1;
          this.getMyPublications();
        }
      }
    },
    async getMyPublications() {
      this.loading = true;
      try {
        const response = await api.get('publications/my-publication-requests/', {
          params: { page: this.page },
        });
        const results = response.data.results || [];
        this.publications = [...this.publications, ...results];
        this.count = response.data.count;
        this.next = response.data.next;
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
  },
  computed: {},
  mounted() {
    window.addEventListener('scroll', this.infiniteScroll);
    updateLastSeen('rejected_publications');
  },
  unmounted() {
    window.removeEventListener('scroll', this.infiniteScroll);
  },
  async created() {
    this.publications = [];
    this.page = 1;
    this.count = 0;
    this.next = null;
    await this.getMyPublications();
  },
};
</script>
